import forestFirst from './forest-first.svg';
import lineHeader from './line-header.svg';
import smartPro from './smart-pro.svg';
import warningGray from './warning-gray.svg';
import landingPageBackground from './landing-page-background.png';
import manageSubscriptions from './manage-subscriptions.svg';

const Images = {
  forestFirst,
  lineHeader,
  smartPro,
  warningGray,
  landingPageBackground,
  manageSubscriptions,
};

export default Images;
